import React from 'react';
import { Button } from './ui/button';
import { ArrowRight, Calendar, Users } from 'lucide-react';

export const Hero = () => {
  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="hero" className="relative min-h-screen flex items-center justify-center pt-20 pb-16 px-4 sm:px-6 lg:px-8 overflow-hidden bg-gradient-to-br from-[#8B1538] via-[#9B1848] to-[#6B1028]">
      {/* Decorative Elements */}
      <div className="absolute top-20 right-0 w-96 h-96 bg-white/5 rounded-full blur-3xl"></div>
      <div className="absolute bottom-20 left-0 w-96 h-96 bg-white/5 rounded-full blur-3xl"></div>
      <div className="absolute inset-0 bg-[url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNjAiIGhlaWdodD0iNjAiIHZpZXdCb3g9IjAgMCA2MCA2MCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48ZyBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPjxwYXRoIGQ9Ik0zNiAxOGMzLjMxNCAwIDYgMi42ODYgNiA2cy0yLjY4NiA2LTYgNi02LTIuNjg2LTYtNiAyLjY4Ni02IDYtNnoiIHN0cm9rZT0iI2ZmZiIgc3Ryb2tlLW9wYWNpdHk9Ii4wNSIvPjwvZz48L3N2Zz4=')] opacity-20"></div>

      <div className="relative max-w-7xl mx-auto">
        <div className="text-center">
          {/* Badge */}
          <div className="inline-flex items-center px-4 py-2 rounded-full bg-white/10 backdrop-blur-sm border border-white/20 shadow-lg mb-8 animate-fade-in">
            <span className="text-white font-semibold text-sm">University of Ottawa • Telfer School of Management</span>
          </div>

          {/* Main Heading */}
          <h1 className="text-5xl sm:text-6xl lg:text-7xl font-bold text-white mb-6 leading-tight">
            Business Skills Are
            <br />
            <span className="text-white/90">Needed Everywhere</span>
          </h1>

          {/* Subheading */}
          <p className="text-xl sm:text-2xl text-white/90 mb-8 max-w-4xl mx-auto leading-relaxed">
            Most Telfer clubs point you toward consulting, accounting, and finance firms. 
            <span className="font-semibold text-white"> Telfer Gateway Society closes that gap</span>, 
            bringing you face-to-face with industries and recruiters you never knew were looking for you.
          </p>

          {/* Sub-description */}
          <p className="text-lg text-white/80 mb-12 max-w-3xl mx-auto">
            Engineering firms. Tech companies. Government agencies. Law firms. Biomedical companies. 
            Your business degree opens more doors than you think.
          </p>

          {/* CTA Buttons */}
          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center mb-16">
            <Button
              onClick={() => scrollToSection('events')}
              size="lg"
              className="bg-white text-[#8B1538] hover:bg-slate-50 px-8 py-6 text-lg font-semibold shadow-xl hover:shadow-2xl transition-all duration-300 transform hover:scale-105 group"
            >
              <Calendar className="mr-2 h-5 w-5" />
              Attend Next Event
              <ArrowRight className="ml-2 h-5 w-5 group-hover:translate-x-1 transition-transform" />
            </Button>
            <Button
              onClick={() => scrollToSection('contact')}
              size="lg"
              variant="outline"
              className="border-2 border-white text-white hover:bg-white hover:text-[#8B1538] px-8 py-6 text-lg font-semibold transition-all duration-300 transform hover:scale-105 group bg-transparent"
            >
              <Users className="mr-2 h-5 w-5" />
              Get Involved
              <ArrowRight className="ml-2 h-5 w-5 group-hover:translate-x-1 transition-transform" />
            </Button>
          </div>

          {/* Stats */}
          <div className="grid grid-cols-2 md:grid-cols-4 gap-8 max-w-4xl mx-auto">
            <div className="text-center bg-white/10 backdrop-blur-sm rounded-2xl p-6 border border-white/20">
              <div className="text-3xl sm:text-4xl font-bold text-white mb-2">15+</div>
              <div className="text-sm sm:text-base text-white/80">Cross-Faculty Events</div>
            </div>
            <div className="text-center bg-white/10 backdrop-blur-sm rounded-2xl p-6 border border-white/20">
              <div className="text-3xl sm:text-4xl font-bold text-white mb-2">30+</div>
              <div className="text-sm sm:text-base text-white/80">Industry Partners</div>
            </div>
            <div className="text-center bg-white/10 backdrop-blur-sm rounded-2xl p-6 border border-white/20">
              <div className="text-3xl sm:text-4xl font-bold text-white mb-2">200+</div>
              <div className="text-sm sm:text-base text-white/80">Active Members</div>
            </div>
            <div className="text-center bg-white/10 backdrop-blur-sm rounded-2xl p-6 border border-white/20">
              <div className="text-3xl sm:text-4xl font-bold text-white mb-2">500+</div>
              <div className="text-sm sm:text-base text-white/80">Career Connections</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
